import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Body, Response } from '../op-types';

/** An issuer kind, read off the wire so no second list exists. */
type OverviewKind = Response<'metricPresetsFindAll'>[number]['defaultFor'][number];

export function createMetricPresetQueries(client: StoxlyClient) {
  return createQueryKeys('metricPresets', {
    // ['metricPresets', 'all']
    all: {
      queryKey: null,
      queryFn: ({ signal }) => client.metricPresetsFindAll({ signal }),
    },
  });
}

export function createMetricPresetMutations(client: StoxlyClient) {
  return {
    create: {
      mutationFn: (body: Body<'metricPresetsCreate'>) => client.metricPresetsCreate(body),
    },
    update: {
      mutationFn: ({ id, ...body }: Body<'metricPresetsUpdate'> & { id: string }) =>
        client.metricPresetsUpdate(body, { params: { id } }),
    },
    delete: {
      mutationFn: (id: string) => client.metricPresetsDelete(undefined, { params: { id } }),
    },
    setDefault: {
      mutationFn: (params: { id: string; kind: OverviewKind }) =>
        client.metricPresetsSetDefault(undefined, { params }),
    },
    clearDefault: {
      mutationFn: (kind: OverviewKind) =>
        client.metricPresetsClearDefault(undefined, { params: { kind } }),
    },
  };
}
